import {
  getNextBlockPage,
  getPageBlockNumbers,
  getPreviousBlockPage,
  PAGE_BLOCK_SIZE,
} from '../utils/pagination';

function Pagination({ page, totalPages, onPageChange }) {
  const safeTotalPages = Math.max(totalPages ?? 1, 1);
  const isFirstPage = page <= 0;
  const isLastPage = page >= safeTotalPages - 1;
  const pageNumbers = getPageBlockNumbers(page, safeTotalPages, PAGE_BLOCK_SIZE);
  const previousPage = getPreviousBlockPage(page, PAGE_BLOCK_SIZE);
  const nextPage = getNextBlockPage(page, safeTotalPages, PAGE_BLOCK_SIZE);

  return (
    <nav className="pagination-bar" aria-label="페이지 이동">
      <button
        type="button"
        className="pagination-arrow"
        disabled={isFirstPage}
        onClick={() => onPageChange(0)}
        aria-label="첫 페이지"
        title="첫 페이지"
      >
        &laquo;
      </button>
      <button
        type="button"
        className="pagination-arrow"
        disabled={isFirstPage}
        onClick={() => onPageChange(previousPage)}
        aria-label={`이전 ${PAGE_BLOCK_SIZE}페이지`}
        title={`이전 ${PAGE_BLOCK_SIZE}페이지`}
      >
        &lsaquo;
      </button>

      <div className="pagination-pages">
        {pageNumbers.map((pageIndex) => {
          const isActive = pageIndex === page;

          if (isActive) {
            return (
              <span
                key={pageIndex}
                className="pagination-page active"
                aria-current="page"
              >
                {pageIndex + 1}
              </span>
            );
          }

          return (
            <button
              key={pageIndex}
              type="button"
              className="pagination-page"
              onClick={() => onPageChange(pageIndex)}
              aria-label={`${pageIndex + 1}페이지`}
            >
              {pageIndex + 1}
            </button>
          );
        })}
      </div>

      <button
        type="button"
        className="pagination-arrow"
        disabled={isLastPage}
        onClick={() => onPageChange(nextPage)}
        aria-label={`다음 ${PAGE_BLOCK_SIZE}페이지`}
        title={`다음 ${PAGE_BLOCK_SIZE}페이지`}
      >
        &rsaquo;
      </button>
      <button
        type="button"
        className="pagination-arrow"
        disabled={isLastPage}
        onClick={() => onPageChange(safeTotalPages - 1)}
        aria-label="마지막 페이지"
        title="마지막 페이지"
      >
        &raquo;
      </button>
    </nav>
  );
}

export default Pagination;
